import React from 'react';
import { Link } from 'react-router-dom';
import { Facebook, Linkedin, Mail, Phone, Printer } from 'lucide-react';
import Logo from './Logo';
import { companyInfo } from '../mock';
import { useLang } from '../i18n/LanguageContext';

const Footer = () => {
  const { t } = useLang();
  const items = [
    { label: t('nav.identita'), href: '/identita' },
    { label: t('nav.prodotti'), href: '/prodotti' },
    { label: t('nav.attivita'), href: '/attivita' },
    { label: t('nav.servizi'), href: '/servizi' },
    { label: t('nav.contatti'), href: '/contatti' },
  ];
  return (
    <footer className="bg-[#0b2545] text-white pt-20 pb-8">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
        <div>
          <Logo dark />
          <p className="mt-6 text-sm leading-relaxed text-white/80">
            {companyInfo.legal}
            <br />
            {companyInfo.legalAddress}
          </p>
          <ul className="mt-6 space-y-1 text-sm text-white/70">
            <li>
              <Link to="/privacy-policy" className="hover:text-white">
                {t('footer.privacy')}
              </Link>
            </li>
          </ul>
          <div className="flex gap-3 mt-6">
            <a href={companyInfo.facebook} target="_blank" rel="noreferrer" aria-label="Facebook" className="w-10 h-10 rounded-full border border-white/30 flex items-center justify-center hover:bg-white hover:text-[#0b2545] transition-colors">
              <Facebook size={18} />
            </a>
            <a href={companyInfo.linkedin} target="_blank" rel="noreferrer" aria-label="LinkedIn" className="w-10 h-10 rounded-full border border-white/30 flex items-center justify-center hover:bg-white hover:text-[#0b2545] transition-colors">
              <Linkedin size={18} />
            </a>
          </div>
        </div>

        <div>
          <h4 className="text-sm uppercase tracking-[0.2em] font-semibold mb-5 text-white">{t('footer.opOffice')}</h4>
          <div dir="ltr" style={{ unicodeBidi: 'isolate', textAlign: 'left' }}>
            <p className="text-sm text-white/80 leading-relaxed">{companyInfo.opAddress}</p>
            <ul className="mt-5 space-y-2 text-sm text-white/80">
              <li className="flex items-center gap-2"><Phone size={14} /> tel. {companyInfo.tel1}</li>
              <li className="flex items-center gap-2"><Phone size={14} /> tel. {companyInfo.tel2}</li>
              <li className="flex items-center gap-2"><Printer size={14} /> fax {companyInfo.fax}</li>
              <li className="flex items-center gap-2"><Mail size={14} /><a href={`mailto:${companyInfo.email}`} className="hover:text-white">{companyInfo.email}</a></li>
            </ul>
            <p className="text-xs text-white/60 mt-5 leading-relaxed">
              P.IVA {companyInfo.piva} · REA n° {companyInfo.rea} · {companyInfo.capital}
            </p>
          </div>
        </div>

        <div>
          <h4 className="text-sm uppercase tracking-[0.2em] font-semibold mb-5 text-white">{companyInfo.ksaLabel}</h4>
          <div dir="ltr" style={{ unicodeBidi: 'isolate', textAlign: 'left' }}>
            <p className="text-sm text-white/80 leading-relaxed whitespace-pre-line">{companyInfo.ksaAddress}</p>
            <ul className="mt-5 space-y-2 text-sm text-white/80">
              <li className="flex items-center gap-2">
                <Phone size={14} /> <span>tel. {companyInfo.ksaPhone}</span>
              </li>
              <li className="flex items-center gap-2">
                <Mail size={14} />
                <a href={`mailto:${companyInfo.ksaEmail}`} className="hover:text-white">{companyInfo.ksaEmail}</a>
              </li>
            </ul>
          </div>
        </div>

        <div>
          <h4 className="text-sm uppercase tracking-[0.2em] font-semibold mb-5 text-white">{t('footer.nav')}</h4>
          <ul className="space-y-3">
            {items.map((n) => (
              <li key={n.href}>
                <Link to={n.href} className="text-sm text-white/80 hover:text-white tracking-wider">
                  {n.label.toUpperCase()}
                </Link>
              </li>
            ))}
          </ul>
        </div>
      </div>

      <div className="border-t border-white/10 mt-14 pt-6 max-w-7xl mx-auto px-6 lg:px-10 text-xs text-white/50 flex flex-col sm:flex-row justify-between gap-2">
        <span>© {new Date().getFullYear()} Fiber Plast S.r.l. — {t('footer.rights')}</span>
        <span>{t('footer.tagline')}</span>
      </div>
    </footer>
  );
};

export default Footer;
